import React from 'react';
import {
  Filter as FilterAdmin,
  TextInput,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Nome" source="search" />
    <ReferenceInput
      label="Empresa"
      source="empresa_id"
      reference="empresa-loja"
      allowEmpty={false}
    >
      <SelectInput optionText="nome_fantasia" allowEmpty={false} />
    </ReferenceInput>
  </FilterAdmin>
);

export default Filter;
